
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scanner",
      function () {
        return require("private-next-pages/scanner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scanner"])
      });
    }
  